import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Grid, IconButton, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { LightTooltip } from '../LightTooltip';
import { InfoIcon } from '../CustomIcons';

interface Props {
  title: string;
  tooltip?: string;
  value: number;
  percentage: number;
}

export const QuickReportWithPercentage: FC<Props> = ({ title, tooltip, value, percentage }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        action={
          tooltip && (
            <LightTooltip title={tooltip} arrow placement="right-start">
              <IconButton size="small">
                <InfoIcon />
              </IconButton>
            </LightTooltip>
          )
        }
        title={title}
      />
      <CardContent>
        <Typography component="p" className={classes.percentContent}>
          {value}
        </Typography>
        <Grid className={`${classes.bottomContent} ${percentage > 0 ? classes.up : percentage !== 0 && classes.down}`}>
          {percentage > 0
            ? `+${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`
            : percentage < 0
            ? `${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`
            : `${percentage}%`}
        </Grid>
      </CardContent>
    </Card>
  );
};
